// "Bay 6 missed your last update" copy for the detail page's banner (W4) and
// the button that fixes it in one click.

/** "Bay 6" / "Bay 6 and Bay 7" / "Bay 6, Bay 7 and Bay 8". */
export function joinNames(names: string[]): string {
  if (names.length <= 1) return names[0] ?? "";
  if (names.length === 2) return `${names[0]} and ${names[1]}`;
  return `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
}

export function buildMissedUpdateMessage(simulatorNames: string[]): string {
  const bays = joinNames(simulatorNames);
  const pronoun = simulatorNames.length === 1 ? "It's" : "They're";
  return `${bays} missed your last update. ${pronoun} still showing the old images.`;
}

export function buildPushUpdateLabel(simulatorNames: string[]): string {
  if (simulatorNames.length === 1) {
    return `Push update to ${simulatorNames[0]}`;
  }
  return `Push update to ${simulatorNames.length} bays`;
}
